/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable prefer-const */
import React, { useState, useEffect, useMemo, useCallback, useRef } from 'react';
import { Row, ButtonGoBack } from '~/components';
import { parseToQueryString } from '~/modules/Helper/querystring-helper';

import { MODO_VISAO } from '~/modules/Helper/modoVisao';
import { NUMERO_QUANTIDADE_REGISTROS } from '~/modules/Helper/numeroQuantidadeRegistros';
import { PARAMS_FILTERS_GRID } from '~/modules/Helper/searchParamsFilters';
import { getAndFormatSearchParams } from '~/modules/Helper/searchString-helper';
import * as ModuloVisaoService from './services/moduloVisao.service';

import Header from './components/Grid/Header.component';
import Totalizadores from './components/Totalizadores/Totalizadores.component';
import TableDinamic from './components/Grid/TableDinamic.component';
import FiltroPeriodicidadeModuloDinamico from './components/Grid/FiltroPeriodicidadeModuloDinamico.component';
import MobileGridFiltrosOrdenacao from './components/Grid/MobileGridFiltrosOrdenacao.component';

import { useGridFiltros } from './hooks/useGridFiltros.hook';
import { useNavegacaoModuloDinamico } from './hooks/useNavegacaoModuloDinamico.hook';
import { useGridOrdenacao } from './hooks/useGridOrdenacao.hook';

import { FILTRO_DEFAULT } from '../Helper/FiltrosPeriodicidade';

const safeJsonParse = (value, fallback = null) => {
  if (!value) return fallback;
  try {
    return JSON.parse(value);
  } catch (e) {
    return fallback;
  }
};

function ModuloDinamicoPage({ match, history }) {

  const routeParams = new URLSearchParams(history.location.search);

  const periodicidadeParam = routeParams.get('periodicidade')?.toUpperCase();
  const periodoParam = routeParams.get('periodo')?.toUpperCase();
  const exercicioParam = Number(routeParams.get('exercicio'));
  const paginacaoGridParam = Number(routeParams.get('pagina'));
  const quantidadeRegistrosParam = routeParams.get('quantidaderegistros');

  const valorFiltroRedirecionaVisaoParam = routeParams.get(
    'valorfiltroredirecionavisao'
  );

  const colunaFiltroRedirecionaVisaoParam = routeParams.get(
    'colunafiltroredirecionavisao'
  );

  const tipoValorFiltroRedirecionaVisaoParam = routeParams.get(
    'tipovalorfiltroredirecionavisao'
  );

  const listaColunaOrdemParam = safeJsonParse(
    routeParams.get('listacolunaordem'),
    null
  );
  const filtrosParam = safeJsonParse(routeParams.get('filtros'), null);

  const [dataUltimaAtualizacao, setDataUltimaAtualizacao] = useState(null);
  const [configuracao, setConfiguracao] = useState(null);
  const [listaPeriodicidades, setListaPeriodicidades] = useState([]);
  const [listaPeriodos, setListaPeriodos] = useState([]);
  const [listaExercicios, setListaExercicios] = useState([]);
  const [possuiArquivoDigital, setPossuiArquivoDigital] = useState(false);
  const [moduloVisao, setModuloVisao] = useState(null);
  const [urlVisaoAnalitica, setUrlVisaoAnalitica] = useState(null);
  const [urlVisaoAgrupamento, setUrlVisaoAgrupamento] = useState(null);
  const [periodoDesabilitado, setPeriodoDesabilitado] = useState(false);
  const [InputCarregando, setInputCarregando] = useState(false);
  const [totalizadores, setTotalizadores] = useState([]);
  const [filtroDefault, setFiltroDefaultEnum] = useState();
  const [filtroExportacao, setFiltroExportacao] = useState([]);
  const [filtroOrdenacaoExportacao, setFiltroOrdenacaoExportacao] = useState(
    []
  );

  // filtros da visão agrupamento
  const [
    colunaFiltroRedirecionaVisao,
    setColunaFiltroRedirecionaVisao,
  ] = useState(null);
  const [
    valorFiltroRedirecionaVisao,
    setValorFiltroRedirecionaVisao,
  ] = useState(null);
  const [
    tipoValorFiltroRedirecionaVisao,
    setTipoValorFiltroRedirecionaVisao,
  ] = useState(null);

  const [periodicidadeSelecionada, setPeriocidadeSelecionada] = useState(null);
  const [periodoSelecionado, setPeriodoSelecionado] = useState(null);
  const [exercicioSelecionado, setExercicioSelecionado] = useState(null);
  const [pagina, setPagina] = useState(1);
  const [quantidadeRegistros, setQuantidadeRegistros] = useState();
  const [exibirArquivosForm, setExibirArquivosForm] = useState(false);
  const [
    filtroPesquisaArquivosDigitais,
    setFiltroPesquisaArquivosDigitais,
  ] = useState(null);
  const [isFiltroAvancadoHabilitado, setIsFiltroAvancadoHabiltado] = useState(
    false
  );

  const { modulo, visao } = match.params;
  const [chavesPeriodicidade, setChavesPeriodicidade] = useState([]);

  const obterVisaoColunas = propriedade => {
    return (
      configuracao?.VisaoColunas?.find(
        x => x.OcultoGridPortal !== true && x[propriedade] // A coluna OcultoGridPortal não deve ser utilizada
      ) || null
    );
  };

  const obterColunaChave = useCallback(() => {
    return (
      obterVisaoColunas('Chave') ||
      obterVisaoColunas('ChaveUnicaModulo') ||
      obterVisaoColunas('ColunaLink') ||
      configuracao?.VisaoColunas?.[0] ||
      null
    );
  }, [configuracao]);

  const obterChaveUnicaModulo = useCallback(() => {
    return obterVisaoColunas('ChaveUnicaModulo') || obterColunaChave();
  }, [configuracao, obterColunaChave]);

  const obterColunaLink = useCallback(() => {
    return obterVisaoColunas('ColunaLink') || obterChaveUnicaModulo();
  }, [configuracao, obterChaveUnicaModulo]);

  const {
    dataFilterHeader,
    filtro,
    filtroDebounce,
    obterMergeFiltro,
    setDataFilterHeader,
    setFiltro,
  } = useGridFiltros({
    configuracao,
    filtrosParam,
    obterColunaChave,
    obterColunaLink,
  });

  const {
    aplicarOrdenacaoFromUrl,
    handleTableChange,
    listaColunaOrdem,
    normalizarListaColunaOrdem,
    obterOrdenacaoPadrao,
    removerColunaOrdenacao,
    setListaColunaOrdem,
    tableKey,
  } = useGridOrdenacao({ configuracao });

  const { carregarPagina, voltarPaginaAnterior } = useNavegacaoModuloDinamico({
    history,
    visao,
    urlVisaoAnalitica,
    urlVisaoAgrupamento,
    filtro,
    setFiltro,
    setColunaFiltroRedirecionaVisao,
    setValorFiltroRedirecionaVisao,
    setTipoValorFiltroRedirecionaVisao,
    setListaColunaOrdem,
    normalizarListaColunaOrdem,
    setExercicioSelecionado,
    setPeriocidadeSelecionada,
    setPeriodoSelecionado,
    setQuantidadeRegistros,
  });

  function obterValoresChavesPeriodicidadePorLinha(linhaGrid) {
    const valores = chavesPeriodicidade.map(colunaGrid => ({
      campo: colunaGrid.FonteDados,
      valor: linhaGrid[colunaGrid.FonteDados],
      tipo: colunaGrid.TipoValor,
    }));
    return valores;
  }

  const exibirAnexos = useCallback(row => {
    const colunasChave = configuracao?.VisaoColunas.filter(
      colunaGrid => colunaGrid.ChaveUnicaModulo
    );

    const chavePesquisa = {
      ChaveModulo: modulo,
      Chave: colunasChave.map(coluna => ({
        Campo: coluna.FonteDados,
        Valor: row[coluna.FonteDados],
        TipoValor: coluna.TipoValor,
      })),
    };

    setFiltroPesquisaArquivosDigitais(chavePesquisa);
    setExibirArquivosForm(true);
  });

  const validaPeriodicidade = useCallback(() => {
    if (!periodicidadeSelecionada) return false;

    const periodoAnualValido =
      periodicidadeSelecionada === 'ANUAL' && !periodoSelecionado;

    let periodoValidoParaPeriodicidade;
    if (periodicidadeSelecionada === null) {
      periodoValidoParaPeriodicidade = listaPeriodicidades;
    } else {
      periodoValidoParaPeriodicidade = listaPeriodicidades.some(
        p =>
          p.Id === periodicidadeSelecionada &&
          p.Periodos &&
          p.Periodos.length &&
          p.Periodos.some(x => x.Id === periodoSelecionado)
      );
    }

    return periodoAnualValido || periodoValidoParaPeriodicidade;
  }, [periodicidadeSelecionada, listaPeriodicidades, periodoSelecionado]);

  function redirecionarDetalheVisaoAnalitica(valoresChavesPeriodicidade) {
    let colunasPeriodicidadeCampoValor = {};

    valoresChavesPeriodicidade.forEach(item => {
      colunasPeriodicidadeCampoValor[item.campo] = item.valor;
    });

    const data = {
      exercicio: exercicioSelecionado,
      periodicidade: periodicidadeSelecionada,
      periodo: periodoSelecionado,

      ...colunasPeriodicidadeCampoValor,
    };

    const queryString = parseToQueryString(data);

    history.push({
      pathname: `${urlVisaoAnalitica}/detalhevisao`,
      state: {
        pagina,
        quantidadeRegistros,
        colunaFiltroRedirecionaVisao,
        valorFiltroRedirecionaVisao,
        tipoValorFiltroRedirecionaVisao,
        listaColunaOrdem,
        filtro,
      },
      search: queryString,
    });
  }

  function redirecionarVisaoAnalitica(
    colunaSelecionada,
    valorSelecionada,
    tipoValorColunaSelecionada
  ) {
    setColunaFiltroRedirecionaVisao(colunaSelecionada);
    setValorFiltroRedirecionaVisao(valorSelecionada);
    setTipoValorFiltroRedirecionaVisao(tipoValorColunaSelecionada);

    history.push({
      pathname: urlVisaoAnalitica,
      state: {
        colunaSelecionada,
        chaveSelecionada: valorSelecionada,
        tipoValorColunaSelecionada,
        exercicio: exercicioSelecionado,
        periodicidade: periodicidadeSelecionada,
        periodo: periodoSelecionado,
        quantidadeRegistros,
        valorFiltroRedirecionaVisao,
        tipoValorFiltroRedirecionaVisao,
        isFromAgrupamento: true,
        listacolunaordem: listaColunaOrdem
          ? JSON.stringify(listaColunaOrdem)
          : null,
      },
    });
  }

  async function redirecionarRastreabilidade(row, visaoRastreabilidade) {
    const rastreabilidade = {
      campo: visaoRastreabilidade.FonteDadosColunaDestino,
      valor: row[visaoRastreabilidade.FonteDadosColunaOrigem],
      tipo: visaoRastreabilidade.TipoValorColunaDestino,
      link: visaoRastreabilidade.LinkVisaoDestino,
    };
    history.push({
      pathname: rastreabilidade.link,
      search: `colunafiltroredirecionavisao=${rastreabilidade.campo}&valorfiltroredirecionavisao=${rastreabilidade.valor}&tipovalorfiltroredirecionavisao=${rastreabilidade.tipo}`,
      state: {
        colunafiltroredirecionavisao: rastreabilidade.campo,
        valorfiltroredirecionavisao: rastreabilidade.valor,
        tipovalorfiltroredirecionavisao: rastreabilidade.tipo,
      },
    });
  }

  const buscaDadosGrid = useCallback(() => {
    if (!filtroDefault) return;

    if (
      filtroDefault !== FILTRO_DEFAULT.SEM_FILTRO &&
      (!validaPeriodicidade() || !exercicioSelecionado)
    ) {
      return;
    }

    if (!configuracao || !listaColunaOrdem?.length) {
      return;
    }
    const FiltroRedirecionaVisao = {
      Campo: colunaFiltroRedirecionaVisao,
      Valor: valorFiltroRedirecionaVisao,
      TipoValor: tipoValorFiltroRedirecionaVisao,
    };

    const mergeFiltro = obterMergeFiltro();

    let data = {
      ChaveModulo: modulo,
      NomeVisao: visao,
      Filtros: mergeFiltro,
      Periodicidade: periodicidadeSelecionada,
      Periodo: periodoSelecionado,
      Exercicio: exercicioSelecionado,
      Pagina: pagina,
      QuantidadeRegistros: quantidadeRegistros,
      Ordenacao: listaColunaOrdem,
      FiltroRedirecionaVisao,
    };
    const dataQueryString = {
      periodicidade: periodicidadeSelecionada,
      periodo: periodoSelecionado,
      exercicio: exercicioSelecionado,
      pagina,
      quantidaderegistros: quantidadeRegistros,
      colunafiltroredirecionavisao: colunaFiltroRedirecionaVisao,
      valorfiltroredirecionavisao: valorFiltroRedirecionaVisao,
      tipovalorfiltroredirecionavisao: tipoValorFiltroRedirecionaVisao,
      listacolunaordem: listaColunaOrdem
        ? JSON.stringify(listaColunaOrdem)
        : null,
      filtros:
        mergeFiltro && Array.isArray(mergeFiltro) && mergeFiltro.length > 0
          ? JSON.stringify(mergeFiltro)
          : null,
    };
    const searchParams = getAndFormatSearchParams(
      dataQueryString,
      PARAMS_FILTERS_GRID
    );

    function filtrarModuloVisao(dataFiltro) {
      setInputCarregando(true);

      setFiltroExportacao(
        dataFiltro.Filtros && dataFiltro.Filtros.length > 0
          ? dataFiltro.Filtros
          : []
      );
      setFiltroOrdenacaoExportacao(
        dataFiltro.Ordenacao && dataFiltro.Ordenacao.length > 0
          ? dataFiltro.Ordenacao
          : []
      );
      ModuloVisaoService.filtrar(dataFiltro)
        .then(res => {
          setModuloVisao(res.data);
          setInputCarregando(false);
        })
        .catch(() => {
          setModuloVisao({
            QuantidadePaginas: 0,
            QuantidadeRegistros: 0,
            Valores: [],
          });
          setInputCarregando(false);
        });
    }

    if (configuracao) {
      if (configuracao.ModoVisao === MODO_VISAO.GridVazia) {
        if (data?.Filtros.length > 0) {
          filtrarModuloVisao(data);
        } else {
          setModuloVisao({
            QuantidadePaginas: 0,
            QuantidadeRegistros: 0,
            Valores: [],
          });
        }
        return;
      }

      if (configuracao.ModoVisao === MODO_VISAO.Manutencao) {
        const query = new URLSearchParams({
          visao: `dinamico/${modulo}/${visao}`,
          titulo: configuracao.Titulo || '',
        });
        history.push(`/manutencao?${query.toString()}`);
      } else {
        // Atualiza a URL pelo history do Router (hash) para o UrlContext registrar.
        // Evita loop: só dá replace se a URL realmente mudou e não perpetua location.state.
        const nextPathname = `/dinamico/${modulo}/${visao}`;
        const nextSearch = searchParams ? `?${searchParams}` : '';

        if (
          history.location.pathname !== nextPathname ||
          history.location.search !== nextSearch
        ) {
          history.replace({ pathname: nextPathname, search: nextSearch });
        }

        filtrarModuloVisao(data);
      }
    }
  }, [
    valorFiltroRedirecionaVisao,
    colunaFiltroRedirecionaVisao,
    tipoValorFiltroRedirecionaVisao,
    periodoDesabilitado,
    exercicioSelecionado,
    modulo,
    pagina,
    periodicidadeSelecionada,
    periodoSelecionado,
    quantidadeRegistros,
    validaPeriodicidade,
    visao,
    listaColunaOrdem,
    configuracao,
    filtroDefault,
    obterMergeFiltro,
  ]);

  const obterConfiguracoes = useCallback(async () => {
    const responseConfiguracao = await ModuloVisaoService.obterConfiguracoes(
      modulo,
      visao
    );

    if (responseConfiguracao?.data) setConfiguracao(responseConfiguracao.data);
  }, [modulo, visao]);

  const obterExerciciosEVisaoAnalitica = useCallback(async () => {
    const responseConfiguracoesGerais = await ModuloVisaoService.obterConfiguracoesGerais(
      modulo
    );

    if (responseConfiguracoesGerais?.data) {
      const {
        NomeVisaoAnalitica,
        NomeVisaoAgrupamento,
        Exercicios: exerciciosBruto,
        PossuiArquivoDigital,
        DataUltimaSicronizacaoModulo,
        Periodicidades: periodicidadesBruto,
        FiltroHabilitado,
        FiltroDefaultEnum,
      } = responseConfiguracoesGerais?.data;

      if (NomeVisaoAnalitica) setUrlVisaoAnalitica(NomeVisaoAnalitica);

      if (NomeVisaoAgrupamento) setUrlVisaoAgrupamento(NomeVisaoAgrupamento);

      if (DataUltimaSicronizacaoModulo)
        setDataUltimaAtualizacao(DataUltimaSicronizacaoModulo);

      if (FiltroHabilitado) setIsFiltroAvancadoHabiltado(FiltroHabilitado);

      if (FiltroDefaultEnum) setFiltroDefaultEnum(FiltroDefaultEnum);

      const Exercicios = (exerciciosBruto || []).reduce((acc, curr) => {
        if (!acc.some(e => e.Exercicio === curr.Exercicio)) acc.push(curr);
        return acc;
      }, []);

      if (Exercicios?.length) {
        await setListaExercicios(Exercicios);

        const exercicioParamExisteArray = Exercicios.find(
          x => x.Exercicio === exercicioParam
        );

        await setExercicioSelecionado(
          exercicioParamExisteArray === undefined
            ? Exercicios[0].Exercicio
            : exercicioParam
        );
      }

      const Periodicidades = (periodicidadesBruto || []).reduce((acc, curr) => {
        if (!acc.some(p => p.Id === curr.Id)) acc.push(curr);
        return acc;
      }, []);

      if (Periodicidades?.length) {
        await setListaPeriodicidades(Periodicidades);

        const periodicidadeDoParam = Periodicidades.find(
          x => x.Id === periodicidadeParam
        );

        await setPeriocidadeSelecionada(
          periodicidadeDoParam === undefined
            ? Periodicidades[0].Id
            : periodicidadeParam
        );
      }

      if (PossuiArquivoDigital !== null && PossuiArquivoDigital !== undefined)
        setPossuiArquivoDigital(PossuiArquivoDigital);
    }
  }, [modulo]);

  function setSearchParams() {
    setTipoValorFiltroRedirecionaVisao(
      tipoValorFiltroRedirecionaVisaoParam || null
    );
    setColunaFiltroRedirecionaVisao(colunaFiltroRedirecionaVisaoParam || null);
    setValorFiltroRedirecionaVisao(valorFiltroRedirecionaVisaoParam || null);
    setPeriodoSelecionado(periodoParam || null);
    setExercicioSelecionado(exercicioParam || null);
    setPagina(paginacaoGridParam || 1);
    setQuantidadeRegistros(
      NUMERO_QUANTIDADE_REGISTROS.includes(quantidadeRegistrosParam)
        ? quantidadeRegistrosParam
        : '10'
    );

    // Importante: quando a ordenação vem da URL, forçamos remount da grid
    // para o AntD sincronizar corretamente o ciclo asc/desc/none do sorter.
    aplicarOrdenacaoFromUrl(listaColunaOrdemParam);
  }

  function obterChavesPeriocidadeDaConfiguracao() {
    const colunasPeriodicidade = configuracao.ChavesPeriodicidades;

    setChavesPeriodicidade(arrayAnterior => [
      ...arrayAnterior,
      ...colunasPeriodicidade,
    ]);
  }

  function desabilitarPeriodo() {
    setPeriodoDesabilitado(true);
    setPeriodoSelecionado(null);
    carregarPagina();
  }

  function configuraPeriodoPorTipoPeriodicidade() {
    setPeriodoDesabilitado(false);
    const exercicio = listaExercicios.find(
      ex => ex.Exercicio === exercicioSelecionado
    );

    if (exercicio) {
      const { IdsPeriodicidadePeriodoUltimoMes } = exercicio;

      if (IdsPeriodicidadePeriodoUltimoMes?.length) {
        const IdPeriodicidadePeriodoSelecionado = IdsPeriodicidadePeriodoUltimoMes.find(
          p => p.IdPeriodicidade === periodicidadeSelecionada
        );
        if (IdPeriodicidadePeriodoSelecionado?.IdPeriodo) {
          const periodoValido = listaPeriodicidades.some(
            e =>
              e.Id === periodicidadeSelecionada &&
              e.Periodos.some(p => p.Id === periodoSelecionado)
          );
          setPeriodoSelecionado(
            periodoValido
              ? periodoSelecionado
              : IdPeriodicidadePeriodoSelecionado.IdPeriodo
          );
          carregarPagina();
        }
      }
    }
  }

  function configuraPeriodo() {
    if (periodicidadeSelecionada === 'ANUAL') {
      desabilitarPeriodo();
    } else if (
      listaExercicios?.length &&
      exercicioSelecionado &&
      periodicidadeSelecionada
    ) {
      configuraPeriodoPorTipoPeriodicidade();
    }
  }

  // set exercicios, exercicio e visao analitica
  useEffect(() => {
    obterExerciciosEVisaoAnalitica();
    obterConfiguracoes();
    setSearchParams();
  }, [obterExerciciosEVisaoAnalitica, obterConfiguracoes]);

  // set ordem inicial
  useEffect(() => {
    const colunaChave =
      configuracao?.Tipo === 2 ? obterColunaChave() : obterColunaLink();

    if (colunaChave && !listaColunaOrdem?.length) {
      obterOrdenacaoPadrao(colunaChave);
    }
    if (configuracao) obterChavesPeriocidadeDaConfiguracao();
  }, [obterColunaLink, obterColunaChave, configuracao]);

  // set periodos
  useEffect(() => {
    if (listaPeriodicidades?.length && periodicidadeSelecionada) {
      const periodicidade = listaPeriodicidades.find(
        x => x.Id === periodicidadeSelecionada
      );

      setListaPeriodos(periodicidade?.Periodos || []);
    }
  }, [periodicidadeSelecionada, listaPeriodicidades]);

  // set periodo
  useEffect(() => {
    configuraPeriodo();
  }, [
    exercicioSelecionado,
    listaExercicios,
    carregarPagina,
    periodicidadeSelecionada,
    periodoSelecionado,
    urlVisaoAnalitica,
    urlVisaoAgrupamento,
    visao,
    listaPeriodicidades,
    configuracao,
  ]);

  // search da grid
  useEffect(() => {
    buscaDadosGrid();
  }, [buscaDadosGrid]);

  useEffect(() => {
    if (configuracao && colunaFiltroRedirecionaVisao) {
      buscaDadosGrid();
    }
  }, [configuracao, colunaFiltroRedirecionaVisao]);

  useEffect(() => {
    if (history.location.state?.pagina) {
      setPagina(history.location.state?.pagina);
    }
  }, [pagina]);

  const Grid = useMemo(() => {
    return configuracao?.VisaoColunas && moduloVisao?.Valores ? (
      <TableDinamic
        moduloVisao={moduloVisao}
        handleTableChange={handleTableChange}
        configuracao={configuracao}
        quantidadeRegistros={quantidadeRegistros}
        setQuantidadeRegistros={setQuantidadeRegistros}
        pagina={pagina}
        setPagina={setPagina}
        modulo={modulo}
        visao={visao}
        filtroExportacao={filtroExportacao}
        filtroOrdenacaoExportacao={filtroOrdenacaoExportacao}
        filtro={filtro}
        setFiltro={setFiltro}
        periodicidadeSelecionada={periodicidadeSelecionada}
        periodoSelecionado={periodoSelecionado}
        exercicioSelecionado={exercicioSelecionado}
        colunaFiltroRedirecionaVisao={colunaFiltroRedirecionaVisao}
        valorFiltroRedirecionaVisao={valorFiltroRedirecionaVisao}
        tipoValorFiltroRedirecionaVisao={tipoValorFiltroRedirecionaVisao}
        redirecionarDetalheVisaoAnalitica={redirecionarDetalheVisaoAnalitica}
        urlVisaoAnalitica={urlVisaoAnalitica}
        urlVisaoAgrupamento={urlVisaoAgrupamento}
        listaColunaOrdem={listaColunaOrdem}
        obterValoresChavesPeriodicidadePorLinha={
          obterValoresChavesPeriodicidadePorLinha
        }
        dataUltimaAtualizacao={dataUltimaAtualizacao}
        redirecionarVisaoAnalitica={redirecionarVisaoAnalitica}
        redirecionarRastreabilidade={redirecionarRastreabilidade}
        possuiArquivoDigital={possuiArquivoDigital}
        exibirAnexos={exibirAnexos}
        filtroPesquisaArquivosDigitais={filtroPesquisaArquivosDigitais}
        exibirArquivosForm={exibirArquivosForm}
        setFiltroPesquisaArquivosDigitais={setFiltroPesquisaArquivosDigitais}
        setExibirArquivosForm={setExibirArquivosForm}
        tableKey={tableKey}
        setDataFilterHeader={setDataFilterHeader}
        dataFilterHeader={dataFilterHeader}
        obterColunaChave={obterColunaChave}
        obterColunaLink={obterColunaLink}
      />
    ) : (
      <></>
    );
  }, [
    valorFiltroRedirecionaVisao,
    colunaFiltroRedirecionaVisao,
    listaColunaOrdem,
    configuracao,
    exercicioSelecionado,
    possuiArquivoDigital,
    filtro,
    modulo,
    moduloVisao,
    pagina,
    periodicidadeSelecionada,
    periodoSelecionado,
    quantidadeRegistros,
    urlVisaoAnalitica,
    urlVisaoAgrupamento,
    visao,
    filtroPesquisaArquivosDigitais,
    exibirArquivosForm,
    exibirAnexos,
    dataUltimaAtualizacao,
  ]);

  useEffect(() => {
    async function obterTotalizadores() {
      const FiltroRedirecionaVisao = {
        Campo: colunaFiltroRedirecionaVisao,
        Valor: valorFiltroRedirecionaVisao,
        TipoValor: tipoValorFiltroRedirecionaVisao,
      };

      const data = {
        ChaveModulo: modulo,
        NomeVisao: visao,
        Filtros: filtro,
        Periodicidade: periodicidadeSelecionada,
        Periodo: periodoSelecionado,
        Exercicio: exercicioSelecionado,
        FiltroRedirecionaVisao,
      };

      const ColunasTotalizadoras = await ModuloVisaoService.obterTotalizadores(
        data
      );

      setTotalizadores(ColunasTotalizadoras.data);
    }

    if (!validaPeriodicidade() || !exercicioSelecionado || !configuracao) {
      return;
    }

    obterTotalizadores();
  }, [
    colunaFiltroRedirecionaVisao,
    valorFiltroRedirecionaVisao,
    tipoValorFiltroRedirecionaVisao,
    modulo,
    visao,
    configuracao,
    filtroDebounce,
    periodicidadeSelecionada,
    periodoSelecionado,
    exercicioSelecionado,
  ]);

  return (
    <>
      <Header configuracao={configuracao} />

      {totalizadores?.length > 0 && (
        <Totalizadores totalizadores={totalizadores} />
      )}

      <FiltroPeriodicidadeModuloDinamico
        filtro={filtro}
        pagina={pagina}
        setPagina={setPagina}
        configuracao={configuracao}
        listaColunaOrdem={listaColunaOrdem}
        removerColunaOrdenacao={removerColunaOrdenacao}
        obterColunaChave={obterColunaChave}
        obterColunaLink={obterColunaLink}
        setFiltro={setFiltro}
        InputCarregando={InputCarregando}
        periodicidadeSelecionada={periodicidadeSelecionada}
        setPeriocidadeSelecionada={setPeriocidadeSelecionada}
        listaPeriodicidades={listaPeriodicidades}
        periodoDesabilitado={periodoDesabilitado}
        periodoSelecionado={periodoSelecionado}
        setPeriodoSelecionado={setPeriodoSelecionado}
        listaPeriodos={listaPeriodos}
        exercicioSelecionado={exercicioSelecionado}
        setExercicioSelecionado={setExercicioSelecionado}
        listaExercicios={listaExercicios}
        isFiltroAvancadoHabilitado={isFiltroAvancadoHabilitado}
        history={history}
        obterOrdenacaoPadrao={obterOrdenacaoPadrao}
        setDataFilterHeader={setDataFilterHeader}
        dataFilterHeader={dataFilterHeader}
      />

      <MobileGridFiltrosOrdenacao
        configuracao={configuracao}
        obterColunaChave={obterColunaChave}
        obterColunaLink={obterColunaLink}
        setDataFilterHeader={setDataFilterHeader}
        dataFilterHeader={dataFilterHeader}
        setFiltro={setFiltro}
        filtro={filtro}
        setPagina={setPagina}
        pagina={pagina}
        listaColunaOrdem={listaColunaOrdem}
        setListaColunaOrdem={setListaColunaOrdem}
        normalizarListaColunaOrdem={normalizarListaColunaOrdem}
        removerColunaOrdenacao={removerColunaOrdenacao}
        obterOrdenacaoPadrao={obterOrdenacaoPadrao}
      />

      {Grid}

      <Row>
        <ButtonGoBack OnClick={voltarPaginaAnterior} />
      </Row>
    </>
  );
}

const ModuloDinamico = ({ history, match }) => {
  const { modulo, visao } = match.params;
  return (
    <ModuloDinamicoPage
      key={`${modulo}-${visao}`}
      history={history}
      match={match}
    />
  );
};

export default ModuloDinamico;
